<template>
    <section
        class="testimonials"
        :style="{...generateStylingVariables(content.style)}"
    >
        <div class="testimonials__inner container container--only-desktop">
            <zoe-atom-text
                v-if="stringIsNotEmpty(content.text.value)"
                class="testimonials__text"
                :item="content.text.value"
            />

            <article
                v-for="(item, index) in content.items"
                :key="index"
                class="testimonials__item container"
            >
                <div class="testimonials__verified-wrapper">
                    <zoe-atom-media
                        class="testimonials__logo"
                        :item="item.logo.value"
                    />

                    <div
                        v-if="stringIsNotEmpty(item.verifiedText.value)"
                        class="testimonials__verified"
                    >
                        <zoe-atom-text
                            class="testimonials__verified-text"
                            :item="item.verifiedText.value"
                        />

                        <div class="testimonials__verified-icon"></div>
                    </div>
                </div>

                <div class="testimonials__content">
                    <zoe-atom-media
                        class="testimonials__media"
                        :item="item.media.value"
                    />

                    <div class="testimonials__information">
                        <zoe-atom-text
                            v-if="stringIsNotEmpty(item.author.value)"
                            class="testimonials__author"
                            :item="item.author.value"
                        />

                        <step-testimonials-stars
                            v-if="content.showStars.value"
                            :stars="item.reviewRatingHalf.value"
                        />
                    </div>
                </div>

                <zoe-atom-text
                    v-if="stringIsNotEmpty(item.text.value)"
                    class="testimonials__text"
                    :item="item.text.value"
                />
            </article>
        </div>
    </section>
</template>

<script>
import ZoeAtomMedia from '../../../../../../resources/components/atoms/media/v1.0.0/zoe-atom-media.vue';
import ZoeAtomText from '../../../../../../resources/components/atoms/text/v1.0.0/zoe-atom-text.vue';
import StepTestimonialsStars from '../testimonials-stars/step-testimonials-stars.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';

export default {
    components: {
        StepTestimonialsStars,
        ZoeAtomText,
        ZoeAtomMedia,
    },

    mixins: [Component],

    methods: {
        generateStylingVariables,
    },
};
</script>

<style lang="scss">
@use 'step-testimonials';
</style>

<style lang="scss" scoped>
.testimonials {
    --background: v-bind('content.style.background.value');
    --item-background: v-bind('content.style.itemBackground.value');
    --checkmark-background: v-bind('content.style.checkmark.background.value');
    --checkmark-icon-color: v-bind('content.style.checkmark.iconColor.value');
    --stars-color: v-bind('content.style.stars.color.value');
    --stars-empty-color: v-bind('content.style.stars.emptyColor.value');
}
</style>
